import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import FormGroup from "@material-ui/core/FormGroup";
import TableHead from "@material-ui/core/TableHead";
import Divider from "@material-ui/core/Divider";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import PopupMessage from "../components/PopupMessage";
import ConfirmDialog from "../components/ConfirmDialog";

import DeselectIcon from "@material-ui/icons/BackspaceOutlined";
import DeleteIcon from "@material-ui/icons/DeleteForeverOutlined";
import VoidIcon from "@material-ui/icons/PausePresentationOutlined";
import IssueIcon from "@material-ui/icons/PresentToAllOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  redCell: {
    color: "red",
  },
});

class OutstandingItemDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      historyErrorString: "",
      historyData: [],
      confirmDelete: false,
      confirmEdit: false,
      errorString: "",
      notifyString: "",
      viewPopup: false,
      actionDone: "",
    };
    this.onClose = this.onClose.bind(this);
    this.onClosePopup = this.onClosePopup.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
  }

  onClosePopup(e) {
    e.preventDefault();
    this.setState({ viewPopup: false });
    if (this.state.actionDone.length > 0) {
      this.props.onAction(e, this.state.actionDone);
    }
  }

  handleDelete(e, action) {
    e.preventDefault();
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    //open confirmation popup
    if (action === 3) {
      this.setState({ confirmDelete: true });
    } else {
      this.setState({ confirmDelete: false });
      // confirmed
      if (action === 1) {
        this.executeAction("D");
      }
    }
  }

  handleEdit(e, action) {
    e.preventDefault();
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (action === 3) {
      this.setState({ confirmEdit: true });
    } else {
      this.setState({ confirmEdit: false });
      // confirmed
      if (action === 1) {
        if (this.props.item.status.toUpperCase() === "VOID") {
          this.executeAction("I");
        } else {
          this.executeAction("V");
        }
      }
    }
  }

  executeAction(actionCode) {
    let items = [this.props.item];
    fetch("on_edit_outstanding_items_action", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        action: actionCode,
        items: items,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
          this.setState({ notifyString: "" });
        } else {
          this.setState({ viewPopup: true });
          if (actionCode === "D") {
            this.setState({
              notifyString: "The outstanding item has been deleted.",
            });
          } else {
            this.setState({
              notifyString: "The outstanding item data has been modified.",
            });
          }

          this.setState({ actionDone: actionCode });
          this.setState({ errorString: "" });
          this.setState({ viewPopup: true });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
        this.setState({ notifyString: "" });
      });
  }

  componentDidMount() {
    this.loadHistory();
  }

  onClose(e) {
    e.preventDefault();
    this.props.onClosePopup(e);
  }

  loadHistory() {
    let amnt =
      this.props.item.amount === undefined
        ? this.props.item.issueAmount
        : this.props.item.amount;
    let dt =
      this.props.item.importDate === undefined
        ? this.props.item.issueDate
        : this.props.item.importDate;
    fetch(this.getUrl("on_item_history_request"), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        checkNumber: this.props.item.checkNumber,
        date: dt,
        amount: amnt,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) {
            this.setState({ historyErrorString: reply.errorString });
          } else {
            this.setState({ historyData: reply.history });
          }
        }
      })
      .catch((error) => {
        this.setState({
          historyErrorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  getUrl(requestType) {
    return requestType;
    /*let myUrl = requestType + '?transit=' + 
		   this.props.accountObject.transit + 
		  '&account=' + this.props.accountObject.account +
		  '&checkNumber=' + encodeURIComponent(this.props.item.checkNumber) +
		  '&date=' + encodeURIComponent(this.props.item.importDate) +
		  '&amount=' + encodeURIComponent(this.props.item.amount) +
		  '&r=' + new Date().getTime() +
		  '&token=' + this.props.secureToken;
		  return myUrl;*/
  }

  render() {
    const { classes } = this.props;
    let data = this.state.historyData;
    let { t } = this.props;
    return (
      <div>
        {this.state.confirmDelete && (
          <ConfirmDialog
            title={t("confirmDelete.label")}
            text={t("deleteItem.label")}
            onCloseConfirm={this.handleDelete}
          />
        )}
        {this.state.confirmEdit && (
          <ConfirmDialog
            title={t("confirmEditAction.label")}
            text={
              this.props.item.status.toUpperCase() === "VOID"
                ? t("issueItem.label")
                : t("voidItem.label")
            }
            onCloseConfirm={this.handleEdit}
          />
        )}
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}

        <Paper elevation={5}>
          <FormGroup row>
            <Typography variant="headline" color="textSecondary">
              &nbsp;&nbsp; {t("outstandingItem.label")}
              &nbsp;&nbsp;
            </Typography>
            <Button onClick={this.onClose} color="primary">
              <DeselectIcon />
              &nbsp;{t("deselect.button")}
            </Button>
            {this.props.canEdit &&
              !this.props.uiExclusionsList.includes("ISSUE_EDIT") && (
                <Tooltip
                  title={
                    this.props.item.status.toUpperCase() === "VOID"
                      ? t("issueThisItem.label")
                      : t("voidThisItem.label")
                  }
                >
                  <Button
                    onClick={(event) => this.handleEdit(event, 3)}
                    color="primary"
                  >
                    {this.props.item.status.toUpperCase() === "VOID" && (
                      <IssueIcon />
                    )}
                    {!(this.props.item.status.toUpperCase() === "VOID") && (
                      <VoidIcon />
                    )}
                    &nbsp;
                    {this.props.item.status.toUpperCase() === "VOID"
                      ? t("issue.label")
                      : t("void.label")}
                  </Button>
                </Tooltip>
              )}
            {this.props.canDelete &&
              !this.props.uiExclusionsList.includes("ISSUE_EDIT") && (
                <Tooltip title={t("deleteThisItem.label")}>
                  <Button
                    onClick={(event) => this.handleDelete(event, 3)}
                    color="primary"
                  >
                    <DeleteIcon />
                    &nbsp;{t("delete.button")}
                  </Button>
                </Tooltip>
              )}
          </FormGroup>
          <Divider />
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "8%" }}>
                  {t("transit.header")}
                </TableCell>
                <TableCell style={{ width: "8%" }}>
                  {t("account.header")}
                </TableCell>
                <TableCell style={{ width: "8%" }}>
                  {t("date.header")}
                </TableCell>
                <TableCell style={{ width: "8%" }}>
                  {t("status.header")}
                </TableCell>
                <TableCell style={{ width: "8%" }}>
                  {t("checkNumber.header")}
                </TableCell>
                <TableCell style={{ width: "8%" }}>
                  {t("amount.header")}
                </TableCell>
                <TableCell style={{ width: "36%" }}>
                  {t("payee.header")}
                </TableCell>
                <TableCell style={{ width: "8%" }}>
                  {t("importDate.header")}
                </TableCell>
                <TableCell style={{ width: "8%" }}>
                  {t("stop.header")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow key={1}>
                <TableCell style={{ width: "8%" }}>
                  {this.props.accountObject.transit}
                </TableCell>
                <TableCell style={{ width: "8%" }}>
                  {this.props.accountObject.account}
                </TableCell>
                <TableCell style={{ width: "8%" }}>
                  {this.props.item.date}
                </TableCell>
                <TableCell style={{ width: "8%" }}>
                  {this.props.item.status}
                </TableCell>
                <TableCell style={{ width: "8%" }} numeric={true}>
                  {this.props.item.checkNumber}
                </TableCell>
                <TableCell style={{ width: "8%" }} numeric={true}>
                  {this.props.item.amount}
                </TableCell>
                <TableCell style={{ width: "36%" }}>
                  {this.props.item.payee}
                </TableCell>
                <TableCell style={{ width: "8%" }}>
                  {this.props.item.importDate}
                </TableCell>
                <TableCell style={{ width: "8%" }} className={classes.redCell}>
                  {this.props.item.stop}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <p> &nbsp;&nbsp;{t("history.label")}&nbsp;&nbsp;</p>
        {this.state.historyErrorString.length > 0 && (
          <h3 style={{ color: "red" }}> {this.state.imageErrorString} </h3>
        )}
        {this.state.historyErrorString.length === 0 && (
          <Paper elevation={5}>
            <List dense={false}>
              {data.map((n) => {
                return (
                  <ListItem>
                    <ListItemText primary={n} secondary={null} />
                  </ListItem>
                );
              })}
            </List>
          </Paper>
        )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(OutstandingItemDetails));
